import { z } from "zod";
import { completionDeliveryIdSchema as id } from "./completionDelivery";
import { completionComponentSourceSchema } from "./completionComponentEffects";
import { legacyWorkflowSourceId } from "./legacyWorkflowIdentity";

export const completionUndoLookupRequestSchema = z.object({ expectedOwnerId: id, expectedCompanyId: id, componentId: id }).strict();
export type CompletionUndoLookupRequest = z.infer<typeof completionUndoLookupRequestSchema>;
const undoSchema = z.object({
  source: completionComponentSourceSchema,
  workspaceSceneId: id.nullable(), fingerprint: z.string().regex(/^[a-f0-9]{64}$/),
  state: z.enum(["ready", "changed", "undone"]),
}).strict();
export const completionUndoLookupResponseSchema = z.object({ ownerId: id, companyId: id, componentId: id, undo: undoSchema.nullable() }).strict();
export type CompletionUndoLookupResponse = z.infer<typeof completionUndoLookupResponseSchema>;

/** Even an empty lookup belongs to one captured owner, company and component. */
export function parseCompletionUndoLookupResponse(input: CompletionUndoLookupRequest, value: unknown): CompletionUndoLookupResponse {
  const result = completionUndoLookupResponseSchema.parse(value);
  if (result.ownerId !== input.expectedOwnerId || result.companyId !== input.expectedCompanyId || result.componentId !== input.componentId) throw new Error("Undo lookup owner or target changed");
  const source = result.undo?.source;
  if (source && (legacyWorkflowSourceId(source.jobId) !== null ? source.workflowResultId !== source.jobId : source.workflowResultId !== undefined)) throw new Error("Undo lookup source changed");
  return result;
}
